import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getPortadoresMovimentacao(context, dados) {
    if (!JwtService.getToken()) throw new Error('Usuário não autenticado');
    ApiService.setHeader();
    const {data} = await ApiService.post('portadoresMovimentacao/access/listar', {...dados, pagina:dados.pagina || 1, quantidadePorPagina:dados.quantidadePorPagina || 25});
    if (!data || data.ERRO || data.PERMITIDO === false || !Array.isArray(data.REGISTROS)) throw new Error('Consulta não confirmada');
    return data;
  },
  async getIndicadoresContaCorrente(context, dados) {
    if (!JwtService.getToken()) throw new Error('Usuário não autenticado');
    ApiService.setHeader();
    const {data} = await ApiService.post('portadoresMovimentacao/access/indicadores', dados);
    if (!data || data.ERRO || data.PERMITIDO !== true || !Array.isArray(data.DIAS)) throw new Error('Consulta não confirmada');
    return data;
  },
  salvaPortadorMovimentacao(context, dados) {
    return new Promise((resolve, reject) => {
        if(JwtService.getToken()) {
            ApiService.setHeader();
            ApiService.post("portadoresMovimentacao/access/salvar", dados).then(({ data }) => {
                resolve(data);
            }).catch(reject);
        } else {
            reject(new Error("Usuário não autenticado"));
        }
    });
  },
  getPortadorMovimentacao(context, dados) {
    return new Promise((resolve, reject) => {
        if (JwtService.getToken()) {
            ApiService.setHeader();
            ApiService.post("portadoresMovimentacao/access/obter", {ID_PORTADOR_MOVIMENTACAO: dados.id, componente: dados.componente}).then(({ data }) => {
                resolve(data);
            }).catch(reject);
        } else {
            reject(new Error("Usuário não autenticado"));
        }
    });
  }, 
  getPortadoresPorUsuario(context, dados) {
    return new Promise(resolve => {
        if(JwtService.getToken()) {
            ApiService.setHeader();
            ApiService.post("portadoresMovimentacao/access/portadoresUsuario", dados).then(({ data }) => {
                resolve(data);
            });
        }
    });
  },
  getMovimentoDoCredito(context, dados) {
    return new Promise(resolve => {
        if (JwtService.getToken()) {
            ApiService.setHeader();
            ApiService.post("portadoresMovimentacao/access/movimentoDeCreditoDoPortadorDeCredito", {ID_PORTADOR_MOVIMENTACAO: dados.id}).then(({ data }) => {
                resolve(data);
            });
        }
    });
  },
  getFluxoDeCaixaRelacionamento(context, dados) {
    return new Promise(resolve => {
        if (JwtService.getToken()) {
            ApiService.setHeader();
            ApiService.post("portadoresMovimentacao/access/relacionamentoFluxoConta", dados).then(({ data }) => {
                resolve(data);
            });
        }
    });
  },
  getMovimentoFluxoDeCaixaRelacionamento(context, dados) {
    return new Promise(resolve => {
        if (JwtService.getToken()) {
            ApiService.setHeader();
            ApiService.post("portadoresMovimentacao/access/movimentoRelacionamentoFluxoConta", dados).then(({ data }) => {
                resolve(data);
            });
        }
    });
  },
  getSaldoPortadorCalculado(context, dados) {
    return new Promise(resolve => {
        if (JwtService.getToken()) {
            ApiService.setHeader();
            ApiService.post("portadoresMovimentacao/access/obterSaldoPorData", dados).then(({ data }) => {
                resolve(data);
            });
        }
    });
  },
  getSaldoPortador(context, dados) {
    return new Promise(resolve => {
        if (JwtService.getToken()) {
            ApiService.setHeader();
            ApiService.post("portadoresMovimentacao/access/calcularSaldo", dados).then(({ data }) => {
                resolve(data);
            });
        }
    });
  },
	deletePortadorMovimentacao(context, dados) {
			return new Promise(resolve => {
					if (JwtService.getToken()) {
							ApiService.setHeader();
							ApiService.post("portadoresMovimentacao/access/excluir", { ID_PORTADOR_MOVIMENTACAO: dados.id, TIPO_INSTITUICAO: dados.tipo, componente: dados.componente }).then(({ data }) => {
									resolve(data);
							});
					}
			});
	}
};

export default {
  state,
  actions,
  mutations,
  getters
};
